import { Guid } from '../guid';
import { MapperBase } from '../../utilities/mapper-base';
import { LexbeCase } from '../case.model';
import { LifeCycle } from '../lifecycle.model';
import { CaseResource } from '../resource/case.resource';
import { AccountToAccountResourceMapper } from './account-to-account-resource.mapper';
import { UserToUserResourceMapper } from './user-to-user-resource.mapper';

export class LexbeCaseToCaseResourceMapper extends MapperBase<LexbeCase, CaseResource> {
	map(source: LexbeCase): CaseResource {
		const dest = {} as CaseResource;
		const mapper = new AccountToAccountResourceMapper();
		const userMapper = new UserToUserResourceMapper();
		dest.caseId = source?.caseId ? source.caseId.toLowerCase() : Guid.Empty;
		dest.caseName = source?.caseName ?? '';
		dest.simpleCaseId = source?.simpleCaseId.toString() ?? '';
		dest.lifeCycle = source?.lifecycle == LifeCycle.Deleted ? 1 : 0;
		dest.accountId = source?.accountId ? source.accountId.toLowerCase() : Guid.Empty;
		dest.account = mapper.map(source?.account);
		dest.users = userMapper.mapCollection(source?.users);
		return dest;
	}

}
